import { campaign, isCampaignActive } from "@/config/site";
import { waMessages } from "@/lib/whatsapp";
import MediaImage from "@/components/feature/MediaImage";
import WhatsAppLink from "@/components/feature/WhatsAppLink";
import Reveal from "@/components/feature/Reveal";

export default function Campaign() {
  const active = isCampaignActive();

  return (
    <section id="kampanya" className="scroll-mt-24 bg-background-200">
      <div className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-24">
        {active ? (
          <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-14">
            <Reveal>
              <div className="overflow-hidden rounded-lg bg-background-100">
                <div className="aspect-[4/3] w-full">
                  <MediaImage
                    src={campaign.image}
                    alt="Profesyonel cilt bakımı kampanyası"
                    className="h-full w-full"
                  />
                </div>
              </div>
            </Reveal>

            <Reveal delay={120}>
              <p className="text-xs uppercase tracking-[0.28em] text-accent-600 md:text-sm">
                Güncel Bakım Fırsatı
              </p>
              <h2 className="mt-4 font-heading text-3xl leading-tight text-primary-800 md:text-5xl">
                Profesyonel cilt bakımında %25 indirim.
              </h2>
              <p className="mt-5 max-w-md text-base leading-relaxed text-foreground-700">
                {campaign.subtitle}
              </p>
              <WhatsAppLink
                message={waMessages.campaign}
                label="Cilt Bakımı Kampanyasını Sor"
                variant="primary"
                size="lg"
                sourceSection="campaign"
                className="mt-8"
              />
            </Reveal>
          </div>
        ) : (
          <Reveal className="mx-auto max-w-2xl text-center">
            <p className="text-xs uppercase tracking-[0.28em] text-accent-600 md:text-sm">
              Güncel Bakım Fırsatları
            </p>
            <h2 className="mt-4 font-heading text-3xl leading-tight text-primary-800 md:text-5xl">
              Güncel bakım fırsatlarını öğrenin.
            </h2>
            <p className="mx-auto mt-5 max-w-md text-base leading-relaxed text-foreground-700">
              Mevcut kampanya ve bakım fırsatları hakkında güncel bilgiyi salonumuzdan
              öğrenebilirsiniz.
            </p>
            <WhatsAppLink
              message={waMessages.campaignAfter}
              label="Fırsatları Sor"
              variant="primary"
              size="lg"
              sourceSection="campaign_expired"
              className="mt-8"
            />
          </Reveal>
        )}
      </div>
    </section>
  );
}